import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const MANAGER_ROLES = ["owner", "manager"];

function Loading() {
  return (
    <div className="flex h-screen items-center justify-center bg-slate-950">
      <Loader2 className="h-10 w-10 animate-spin text-[#A0148C]" />
    </div>
  );
}

// Back-office guard. Drivers are redirected to their portal.
export default function ProtectedRoute({ children, ownerOnly = false, managerOnly = false }) {
  const { user } = useAuth();

  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/login" replace />;
  if (user.role === "driver") return <Navigate to="/portal" replace />;
  if (ownerOnly && user.role !== "owner") return <Navigate to="/board" replace />;
  if (managerOnly && !MANAGER_ROLES.includes(user.role)) return <Navigate to="/board" replace />;
  return children;
}

// Driver-only guard for the customer portal.
export function DriverRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/login" replace />;
  if (user.role !== "driver") return <Navigate to="/board" replace />;
  return children;
}
